import axios from 'axios';

export const getMetaTagValue = (name: string) => {
  const selector = document.head.querySelector(`meta[name="${name}"]`);
  if (!selector) {
    return null;
  }
  return selector.getAttribute('content');
};

axios.interceptors.request.use((config) => {
  const headers = new axios.AxiosHeaders(config.headers);

  headers.set('Accept', 'application/json');
  headers.set('X-CSRF-Token', getMetaTagValue('csrf-token'));

  return {
    ...config,
    headers,
  };
});

export default axios;
